import { AudioSourceType } from 'APP/constants/app';
import Entities from 'STORE';
import { TPauseAudioSourceCallback } from 'STORE/App/App.types';

export function removeSource(type: AudioSourceType, callback?: TPauseAudioSourceCallback): void {
  Entities.App.removeCurrentAudioSource(type, callback);
}
